import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Guarantee() {
  return <section className="pb-20 relative" data-id="element-136">
      <div className="container mx-auto px-4" data-id="element-137">
        <FadeIn delay={0.2} data-id="element-138">
          <div className="max-w-2xl mx-auto glass-card border-gold-500/20 bg-navy-800/80 text-center flex flex-col items-center" data-id="element-139">
            <div className="bg-gold-500/10 p-4 rounded-full mb-6" data-id="element-140">
              <ShieldCheckIcon className="w-12 h-12 text-gold-500" data-id="element-141" />
            </div>

            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-142">
              Garantía de 7 días
            </h3>

            <p className="text-lg text-slate-300 leading-relaxed" data-id="element-143">
              Prueba el eBook por 7 días. Si lo abres, lo trabajas y sientes que
              no es para ti, me escribes y te devuelvo tu dinero.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}